module.exports = __webpack_public_path__ + "img/20211013_3.68779d54.png";